import * as actionsProg from '../Actions/Programs';

export const programsReducer = (state = {}, action) => {
      switch (action.type) {
          case actionsProg.GET_PROGS_DATA_REQUESTED:
              return { ...state, isLoading: true };
          case actionsProg.GET_PROGS_DATA_DONE:
              return { ...state, isLoading: false, programs: action.payload };
          case actionsProg.GET_PROGS_DATA_FAILED:
              return { ...state, isLoading: false, isError: true, error: action.payload };
          case actionsProg.SET_SELCTED_PROGS_DATA:
            return { ...state, selected: action.payload };
          default:
              return state;
      }
 };

